// extracted by mini-css-extract-plugin
module.exports = {"endDate":"endDate__1yDpA","text":"text__vwpq4"};